import { db, storage } from "../../firebase/firebase";
import { all, call, fork, put, takeLatest, select } from "redux-saga/effects";
import AuthActions from "../redux/Auth";
import UserActions, { userTypes } from "../redux/User";
import MessageActions from "../redux/Messages";
import { getAffiliatesRequest } from "../services/Affiliates";
import { getAffiliationRequestsRequest } from "../services/AffiliationRequests";
import { 
  getAllClientsRequest,
  getAllMajoristsRequest,
  getDashboardRequest,
  editUserRequest,
  getUsersRequest,
  getAllProductsRequest,
} from "../services/User";
import { getOrdersLength, getOrdersRequest } from "../services/Orders";

export function* getAllMajorists() {
  const { user } = yield select(state => state.user);
  yield put(AuthActions.showAuthLoader())
  const affiliationRequests = yield call(getAffiliationRequestsRequest, user.id)
  const affiliates = yield call(getAffiliatesRequest, user.id)
  const majorists = yield call(getAllMajoristsRequest, affiliationRequests, affiliates);
  yield put(UserActions.getAllMajorsDone(majorists));
  yield put(AuthActions.hideAuthLoader());
}

export function* getAllClients() {
  const { user } = yield select(state => state.user);
  yield put(AuthActions.showAuthLoader())
  const affiliationRequests = yield call(getAffiliationRequestsRequest, user.id)
  const affiliates = yield call(getAffiliatesRequest, user.id)
  const clients = yield call(getAllClientsRequest, affiliationRequests, affiliates);
  yield put(UserActions.getAllClientsDone(clients));
  yield put(AuthActions.hideAuthLoader());
}

export function* getDashboard() {
  const { user } = yield select(state => state.user);
  yield put(AuthActions.showAuthLoader())
  const orders = yield call(getOrdersRequest, user.id)
  const invoices = yield call(getOrdersRequest, user.id, 'completed')
  if(user.rol === 'client') {
    const dashboard = yield call(getDashboardRequest, user.id, user.rol, orders, invoices)
    yield put(UserActions.getDashboardDone(dashboard));
  } else {
    const cancelled = yield call(getOrdersRequest, user.id, 'cancelled')
    const waiting = yield call(getOrdersRequest, user.id, 'waiting')
    const dashboard = yield call(getDashboardRequest, user.id, user.rol, orders, invoices, cancelled, waiting)
    yield put(UserActions.getDashboardDone(dashboard));
  }
  yield put(AuthActions.hideAuthLoader());
}

export function* editUser({user}) {
  yield put(AuthActions.showAuthLoader())
  yield call(editUserRequest, user)
  yield put(AuthActions.getUserInfo(user.id));
  yield put(AuthActions.hideAuthLoader());
}

export function* getUsers({user}) {
  const users = yield call(getUsersRequest, user);
  yield put(UserActions.getUsersDone(users));
}

export function* getProductsAdmin() {
  const products = yield call(getAllProductsRequest);
  yield put(UserActions.getProductsAdminDone(products));
}

export function* getAllMajoristsWatcher() {
  yield takeLatest(userTypes.GET_ALL_MAJORS, getAllMajorists);
}

export function* getAllClientsWatcher() {
  yield takeLatest(userTypes.GET_ALL_CLIENTS, getAllClients);
}

export function* getDashboardWatcher() {
  yield takeLatest (userTypes.GET_DASHBOARD, getDashboard);
}

export function* editUserWatcher() {
  yield takeLatest (userTypes.EDIT_USER, editUser);
}

export function* getUsersWatcher() {
  yield takeLatest(userTypes.GET_USERS, getUsers)
}

export function* getProductsAdminWatcher() {
  yield takeLatest(userTypes.GET_PRODUCTS_ADMIN, getProductsAdmin)
}

export default function* rootSaga() {
  yield all([
    fork(getAllMajoristsWatcher),
    fork(getAllClientsWatcher),
    fork(getDashboardWatcher),
    fork(editUserWatcher),
    fork(getUsersWatcher),
    fork(getProductsAdminWatcher),
  ]);
}